import * as React from 'react';
import IButton, { TButton } from './IButton';
import * as style from './ButtonStyle.module.scss'

const Button: React.SFC<IButton> = ({
  hasTooltip = false,
  label,
  children,
  disabled,
  onBtnClick,
  className,
  ...restProps
}): JSX.Element => {

  const renderLabel = () => {
    return hasTooltip ? label : children;
  };

  const renderTooltip = () => {
    const tooltip = (
      <div className={style.tooltip}>{children}</div>
    );
    return hasTooltip ? tooltip : null;
  };

  return (
    <div className={style.tooltipWrapper}>
      <button
        disabled={disabled || false}
        onClick={onBtnClick}
        className={className}
        {...restProps}
      >
        {renderLabel()}
      </button>
      {renderTooltip()}
    </div>
  );
};

export default Button;

